import React from 'react';
import PropTypes from 'prop-types';
import ModelSelector from '../ModelSelector';

const StepConfig = ({ formData, updateAdditionalConfig, model, setModel, llmConfig, setLLMConfig, models, errors, availableProviders }) => {
  const config = formData.additional_config || {};

  return (
    <div className="wizard-step">
      <div className="step-intro">
        <h3>Configure additional options</h3>
        <p>Select your AI model and fine-tune your prompt with additional constraints. All fields are optional.</p>
      </div>

      <div className="config-grid">
        <div className="form-group model-selector-group">
          <ModelSelector
            model={model}
            setModel={setModel}
            llmConfig={llmConfig}
            setLLMConfig={setLLMConfig}
            models={models}
            availableProviders={availableProviders}
          />
        </div>

        <div className="form-group">
          <label htmlFor="output_constraints" className="form-label">
            Output Constraints
            <span className="label-optional"> (Optional)</span>
          </label>
          <textarea
            id="output_constraints"
            value={config.output_constraints || ''}
            onChange={(e) => updateAdditionalConfig('output_constraints', e.target.value)}
            placeholder="e.g., Maximum 200 words, use bullet points..."
            className="form-textarea"
            rows="3"
          />
        </div>

        <div className="form-group">
          <label htmlFor="must_include" className="form-label">
            Must Include
            <span className="label-optional"> (Optional)</span>
          </label>
          <textarea
            id="must_include"
            value={config.must_include || ''}
            onChange={(e) => updateAdditionalConfig('must_include', e.target.value)}
            placeholder="e.g., Always include a greeting and sign-off..."
            className="form-textarea"
            rows="3"
          />
        </div>

        <div className="form-group">
          <label htmlFor="must_avoid" className="form-label">
            Must Avoid
            <span className="label-optional"> (Optional)</span>
          </label>
          <textarea
            id="must_avoid"
            value={config.must_avoid || ''}
            onChange={(e) => updateAdditionalConfig('must_avoid', e.target.value)}
            placeholder="e.g., Never admit fault, avoid technical jargon..."
            className="form-textarea"
            rows="3"
          />
        </div>

        <div className="form-group">
          <label htmlFor="special_instructions" className="form-label">
            Special Instructions
            <span className="label-optional"> (Optional)</span>
          </label>
          <textarea
            id="special_instructions"
            value={config.special_instructions || ''}
            onChange={(e) => updateAdditionalConfig('special_instructions', e.target.value)}
            placeholder="e.g., Always maintain professional tone even with angry customers..."
            className="form-textarea"
            rows="3"
          />
        </div>
      </div>
    </div>
  );
};

StepConfig.propTypes = {
  formData: PropTypes.shape({
    additional_config: PropTypes.shape({
      output_constraints: PropTypes.string,
      must_include: PropTypes.string,
      must_avoid: PropTypes.string,
      special_instructions: PropTypes.string,
    }),
  }).isRequired,
  updateAdditionalConfig: PropTypes.func.isRequired,
  model: PropTypes.string.isRequired,
  setModel: PropTypes.func.isRequired,
  llmConfig: PropTypes.object,
  setLLMConfig: PropTypes.func,
  models: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    provider: PropTypes.string.isRequired,
  })).isRequired,
  errors: PropTypes.object,
  availableProviders: PropTypes.shape({
    openai: PropTypes.bool,
    anthropic: PropTypes.bool,
    groq: PropTypes.bool,
  }),
};

StepConfig.defaultProps = {
  errors: {},
  llmConfig: null,
  setLLMConfig: null,
  availableProviders: null,
};

export default StepConfig;
